import { render, staticRenderFns } from "./MajorProduct.vue?vue&type=template&id=cbe92b46&scoped=true&"
import script from "./MajorProduct.vue?vue&type=script&lang=js&"
export * from "./MajorProduct.vue?vue&type=script&lang=js&"
import style0 from "./MajorProduct.vue?vue&type=style&index=0&id=cbe92b46&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbe92b46",
  null
  
)

export default component.exports